import { Button, IconButton, Tooltip } from '@assembly-js/design-system';
import type { CSSProperties } from 'react';

import { HELP_CENTER_PAGE } from 'src/constants';
import { usePortalHealthStatus } from 'src/hooks/usePortalHealthStatus';
import { UrlUtils } from 'src/utils';

import { useSidebarTheme } from './useSidebarTheme';

interface SidebarBottomBarProps {
  onSettingsClick: () => void;
  onHelpCenterClick: () => void;
  isClient: boolean;
  isHelpCenterOpen: boolean;
  isSettingsSelected: boolean;
}

const PortalButton = () => {
  const { isPortalReady, clientExperienceLink } = usePortalHealthStatus();

  return (
    <Button
      label="Open portal"
      suffixIcon="ArrowNE"
      variant="secondary"
      size="sm"
      className="rounded-full bg-transparent"
      disabled={!isPortalReady}
      onClick={() =>
        window.open(UrlUtils.GetFullUrl(clientExperienceLink), '_blank')
      }
    />
  );
};

export const SidebarBottomBar = ({
  onSettingsClick,
  onHelpCenterClick,
  isClient,
  isHelpCenterOpen,
  isSettingsSelected,
}: SidebarBottomBarProps) => {
  const {
    sidebarTheme: { sidebarTextColor, sidebarItemHoverBackground },
  } = useSidebarTheme();
  const clientSidebarStyles = {
    color: sidebarTextColor,
    borderColor: 'transparent',
    '--sidebar-hover-bg': sidebarItemHoverBackground,
  } as CSSProperties;

  return (
    <div className="flex gap-1 px-2 py-1">
      <Tooltip content="Settings" position="right">
        <div aria-current={isSettingsSelected ? 'page' : undefined}>
          <IconButton
            icon="Settings"
            variant="secondary"
            size="sm"
            className={`rounded-full bg-transparent ${isClient ? '[color:var(--sidebar-text)] hover:!bg-[var(--sidebar-hover-bg)]' : ''}`}
            style={isClient ? clientSidebarStyles : undefined}
            onClick={onSettingsClick}
          />
        </div>
      </Tooltip>
      {!isClient && (
        <Tooltip content={HELP_CENTER_PAGE.label} position="right">
          <div aria-expanded={isHelpCenterOpen}>
            <IconButton
              icon="QuestionMark"
              variant="secondary"
              size="sm"
              className="rounded-full bg-transparent"
              onClick={onHelpCenterClick}
            />
          </div>
        </Tooltip>
      )}
      {!isClient && <PortalButton />}
    </div>
  );
};
